import React, { useEffect, useState } from "react";
import { Box, Heading, Table, Thead, Tbody, Tr, Th, Td, Spinner, Input, HStack, Button } from "@chakra-ui/react";
import { saApi } from "../../api/superAdminApi";

const Users = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await saApi.listUsers();
      const list = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : [];
      const filtered = search
        ? list.filter((u) =>
            [u.email, u.first_name, u.last_name].filter(Boolean).join(" ").toLowerCase().includes(search.toLowerCase())
          )
        : list;
      setItems(filtered);
    } catch (e) {
      setError("Failed to load users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <HStack justify="space-between" mb={4}>
        <Heading size="md">All Users</Heading>
        <HStack>
          <Input placeholder="Search" value={search} onChange={(e) => setSearch(e.target.value)} size="sm" w="240px" />
          <Button size="sm" onClick={load}>Search</Button>
        </HStack>
      </HStack>
      {loading ? (
        <Spinner />
      ) : error ? (
        <Box color="red.500">{error}</Box>
      ) : (
        <Table variant="simple" bg="white" borderWidth="1px" borderRadius="md">
          <Thead>
            <Tr>
              <Th>User ID</Th>
              <Th>Email</Th>
              <Th>Name</Th>
              <Th>Company ID</Th>
            </Tr>
          </Thead>
          <Tbody>
            {items.map((u) => (
              <Tr key={u.id}>
                <Td>{u.id}</Td>
                <Td>{u.email}</Td>
                <Td>{[u.first_name, u.last_name].filter(Boolean).join(" ")}</Td>
                <Td>{u.company_id}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      )}
    </Box>
  );
};

export default Users;


